module.exports = __webpack_public_path__ + "img/tradingproductForex.4e0fa53f.png";